var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',[_c('template',{slot:"primary"},[_c('button',{staticClass:"button",on:{"click":function($event){return _vm.showModal('modal-html-custom-attributes')}}},[_vm._v(" MANAGE ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }